import { cn } from 'components/UI/cn'
import { ToolbarDensity } from 'components/Tables/CommonTableCells/ToolbarDensityContext'

/**
 * Shared styling for the Deals board toolbar's quick-filter triggers (Owner,
 * Visible Stages) so they stay visually identical. `focus:outline-none` drops
 * the browser's default blue focus ring that Radix surfaces when it returns
 * focus to the trigger after the menu closes — the open/closed state and the
 * count badge already communicate the control's state.
 *
 * Density-driven like the rest of the toolbar: pass the value from
 * `useToolbarDensity()` so the trigger reverts to md (38px) without a
 * `ToolbarDensityProvider` and shrinks to h-8 under one — same pattern as
 * `TableButton`, rather than a hardcoded height.
 */
export function boardFilterTriggerClass(
  density: ToolbarDensity = 'md'
): string {
  return cn(
    'gap-2 !border-neutral-300 !text-neutral-800 hover:!bg-neutral-100 hover:!text-neutral-900 focus:outline-none focus-visible:outline-none',
    density === 'sm' ? '!h-8 !min-h-8' : 'min-h-[38px]'
  )
}

/** The small "All" / count pill inside a board quick-filter trigger. */
export const boardFilterBadgeClass =
  'rounded-full bg-neutral-100 px-1.5 text-xs font-medium tabular-nums text-neutral-600'
